import styled from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const Wrapper = styled.div`
	padding-top: 22px;
`;

export const SwitchRow = styled.div`
	display: flex;
	gap: 24px;
`;

export const ButtonWrapper = styled.div`
	button {
		padding: 8px 12px;
		font-size: 14px;
		line-height: 19px;
		font-weight: 600;

		@media (${BREAKPOINTS.MOBILE}) {
			padding: 6px 8px;
		}
	}
`;
